// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2f2Up","colBig":"styles_colBig__IWeRp","colSmall":"styles_colSmall__GFPbO"};